import StepsTipo from './StepsTipo';
import initialState from '../../../store/initialState';

export const StepReducer = (state = initialState.steps, action) => {
  switch (action.type) {
    case StepsTipo.data.VALIDAR_STEP_ACTUAL:
      return ({
        ...state,
        stepActual: action.payload.stepActual,
        stepEstado: action.payload.stepEstado,
        stepAnterior: action.payload.stepAnterior
      });
    case StepsTipo.data.coordenadas.INICIO_OBTENER_DESAFIO:
      return ({
        ...state,
        enEjecucionAPIObtenerDesafio: action.payload.enEjecucionAPIObtenerDesafio
      });
    case StepsTipo.data.coordenadas.GUARDAR_COORDENADAS:
      return ({
        ...state,
        enEjecucionAPIObtenerDesafio: false,
        coordenadas: { ...action.payload.coordenadas }
      })
    case StepsTipo.data.coordenadas.ERROR_COORDENADAS:
      return ({
        ...state,
        status: 500,
        mensaje: action.payload.mensajeError
      });
    default:
      return state;
  }
}


export const realizarFormalizacionCreditoReducer = (state = initialState.formalizacionCredito, action) => {
  if (action.type === StepsTipo.data.INICIO_FORMALIZAR_CREDITO) {
    return {
      ...state,
      enEjecucionFormalizacionAPI: action.payload.enEjecucionFormalizacionAPI
    };
  }
  if (action.type === StepsTipo.data.FORMALIZAR_CREDITO) {
    return {
      ...state,
      enEjecucionFormalizacionAPI: false,
      formalizacion: action.payload.formalizacion
    };
  }
  if (action.type === StepsTipo.data.ERROR) {
    return {
      ...state,
      enEjecucionFormalizacionAPI: false,
      errorFormalizacion: action.payload.errores
    };
  }
  return state;
}

export const obtenerDocumentosReducer = (state = initialState.documentosCredito, action) => {
  switch (action.type) {
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_1:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_1: action.payload.enEjecucionObtenerDocumentoAPI_1
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_1:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_1: false,
        DoctoSolicitudProductoDeCredito_1: action.payload.DoctoSolicitudProductoDeCredito_1
      };
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_2:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_2: action.payload.enEjecucionObtenerDocumentoAPI_2
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_2:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_2: false,
        DoctMandatoEspecialDeSuscripcion_2: action.payload.DoctMandatoEspecialDeSuscripcion_2
      };
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_3:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_3: action.payload.enEjecucionObtenerDocumentoAPI_3
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_3:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_3: false,
        DoctAnexoLiquidacionDeCredito_3: action.payload.DoctAnexoLiquidacionDeCredito_3
      };
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_4:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_4: action.payload.enEjecucionObtenerDocumentoAPI_4
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_4:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_4: false,
        DoctContratoDeCredito_4: action.payload.DoctContratoDeCredito_4
      };
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_5:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_5: action.payload.enEjecucionObtenerDocumentoAPI_5
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_5:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_5: false,
        DoctHojaResumenDeCredito_5: action.payload.DoctHojaResumenDeCredito_5
      };
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_6:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_6: action.payload.enEjecucionObtenerDocumentoAPI_6
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_6:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_6: false,
        DoctAnexoServicioAtencionAlCliente_6: action.payload.DoctAnexoServicioAtencionAlCliente_6
      };
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_7:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_7: action.payload.enEjecucionObtenerDocumentoAPI_7
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_7:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_7: false,
        DoctSolIncorporacionYCertDeSeguros_7: action.payload.DoctSolIncorporacionYCertDeSeguros_7
      };
    case StepsTipo.data.documentos.INICIO_OBTENER_DOCUMENTOS_8:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_8: action.payload.enEjecucionObtenerDocumentoAPI_8
      };
    case StepsTipo.data.documentos.GUARDAR_DOCUMENTO_8:
      return {
        ...state,
        enEjecucionObtenerDocumentoAPI_8: false,
        DoctPagare_8: action.payload.DoctPagare_8
      };
    case StepsTipo.data.documentos.ERROR:
      return {
        ...state,
        errorApi: action.payload.error
      };
    default:
      return state;
  }
}

export const cursarCreditoReducer = (state = initialState.cursarCredito, action) => {
  switch (action.type) {
    case StepsTipo.data.cursar.INICIO_CURSAR_CREDITO:
      return ({
        ...state,
        enEjecucionCursarCreditoAPI: action.payload.enEjecucionCursarCreditoAPI
      });
    case StepsTipo.data.cursar.CURSAR_CREDITO:
      return {
        ...state,
        enEjecucionCursarCreditoAPI: false,
        curse: action.payload.curse
      };
    case StepsTipo.data.cursar.ERROR_CURSAR:
      return {
        ...state,
        status: action.payload.statusError,
        mensaje: action.payload.mensajeError
      };
    case StepsTipo.data.cursar.SET:
        return {
          ...state,
          enEjecucionCursarCreditoAPI: false,
          curse: null,
          errorApi: null,
          status: null,
          mensaje: null
        };
    default:
      return state;
  }
}

export const autorizacionReducer = (state = initialState.autorizacion, action) => {
  switch (action.type) {
    case StepsTipo.data.autorizar.INICIO_AUTORIZACION:
      return ({
        ...state,
        enEjecucionAutorizarAPI: action.payload.enEjecucionAutorizarAPI
      });
    case StepsTipo.data.autorizar.AUTORIZAR:
      return ({
        ...state,
        enEjecucionAutorizarAPI: action.payload.enEjecucionAutorizarAPI,
        autorizacion: action.payload.autorizacion,
        status: null,
        mensaje: null
      });
    case StepsTipo.data.autorizar.ERROR:
      return ({
        ...state,
        enEjecucionAutorizarAPI: action.payload.enEjecucionAutorizarAPI,
        status: action.payload.statusError,
        mensaje: action.payload.mensajeError,
        autorizacion:false
      });
    case StepsTipo.data.autorizar.OBTENER:
        return ({
          ...state,
          enEjecucionAutorizarAPI: action.payload.enEjecucionAutorizarAPI,
          datoRecibido: action.payload.datoRecibido,
          tipoAutorizacion: action.payload.tipoAutorizacion,
          status: null,
          mensaje: null
        });
    default:
      return state;
  }
}

export const seguroReducer = (state = initialState.seguros, action) => {
  if (action.type === StepsTipo.data.seguros.BUSCA_SEGUROS) {
    return {
      ...state,
      enEjecucionAPI: true
    };
  }
  if (action.type === StepsTipo.data.seguros.OBTIENE_SEGUROS) {
    return {
      ...state,
      enEjecucionAPI: false,
      lista: action.payload.lista
    };
  }
  if (action.type === StepsTipo.data.seguros.SELECION_SEGURO){
    return {
      ...state,
      seleccion: action.payload.seleccion
    };
  }
  if (action.type === StepsTipo.data.seguros.ERROR) {
    return {
      ...state,
      enEjecucionAPI: false,
      lista: [],
      error:true
    };
  }
  return state;
}